<template>
  <div v-loading="loading">
    <div v-if="hasData">
      <el-dropdown class="message-box-action">
        <span class="el-dropdown-link">
          <i class="icon-others" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="userAction('report')">
            {{ $t('chat-message.report.text') }}
          </el-dropdown-item>
          <el-dropdown-item @click.native="userAction('block')">
            {{ $t('chat-message.block.text') }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-row class="display-message">
        <div class="display-message-wrapper">
          <div
            v-if="!isMobile"
            class="message-header"
          >
            <div class="left">
              <img
                v-if="receiverUser && receiverUser.file"
                slot="image"
                class="carousel-img img-circle profile-image"
                :src="receiverUser.file.url_view | resizeImage(40, 40)"
                :data-src="receiverUser.file.url_view | resizeImage(40, 40)"
              >
              <img
                v-else
                src="../../assets/profile-default.png"
                class="carousel-img img-circle profile-image"
              >
              <h2
                v-if="receiverUser"
                class="name"
              >
                {{ receiverUser.name }}
              </h2>
            </div>
            <div
              class="right pointer"
              @click="goToAd(messageSample.ad.id)"
            >
              <div class="name">
                <h4
                  v-if="messageSample"
                  class="m-0"
                >
                  {{ messageSample.ad.name }}
                </h4>
                <h6
                  v-if="messageSample && messageSample.ad && messageSample.ad.price"
                  class="m-0"
                >
                  {{ adCurrency }} {{ messageSample.ad.price }}
                </h6>
              </div>
              <img
                v-if="messageSample && messageSample.ad && messageSample.ad.file"
                slot="image"
                class="carousel-img img-rounded"
                style="margin: auto"
                :src="messageSample.ad.file.url_view | resizeImage(40, 40)"
                :data-src="messageSample.ad.file.url_view | resizeImage(40, 40)"
              >
            </div>
          </div>
          <el-col
            ref="scrollWrapper"
            @scroll.passive.native="loadLazyImagesDebounce"
            class="message-content"
          >
            <entity-list
              ref="messagesBox"
              res="messages"
              :filter="filter"
              :sort="sort"
              infinite-scroll-position="top"
              :infinite-scroll-debounce-time="1000"
              :res-options="resourceOptions"
              @response="$event.current_page === 1 ? initialScroll() : scrollOnResponse(0, true)"
            >
              <template
                slot="list"
                slot-scope="slotProps"
              >
                <chat-message
                  ref="chatMessage"
                  v-for="(item, index) in reverse(slotProps.list)"
                  :key="index"
                  :message="item"
                  :is-user-logged="item.created_by === user.id"
                  :is-read="false"
                />
              </template>
            </entity-list>
            <chat-message
              ref="chatMessage"
              class="is-writing-message"
              v-if="isWriting"
              :message="messageSample"
              :writting="isWriting"
            />
          </el-col>
        </div>
      </el-row>
      <div class="wright-message">
        <el-form
          :model="form"
          @submit.native.prevent="submit"
        >
          <el-form-item :error="error('content')">
            <el-input
              v-if="!isMobile"
              v-model="content"
              type="textarea"
              rows="1"
              :placeholder="$t('message-box.type.text')"
              @keyup.enter.native="submit"
              @input="change('content')"
            />
            <div
              v-else
              class="user-contact-container"
            >
              <div class="message-input">
                <el-input
                  v-model="content"
                  :placeholder="$t('message-box.type.text')"
                />
                <i
                  class="icon-send"
                  @click="submit"
                />
              </div>
              <div>
                <el-button
                  class="phone"
                  icon="icon-phone-receiver"
                  circle
                />
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div
          v-if="!isMobile"
          class="icon-wrapper"
          @click="submit"
        >
          <i class="icon-send" />
        </div>
        <!--<el-upload-->
        <!--class="upload-demo"-->
        <!--action="https://jsonplaceholder.typicode.com/posts/"-->
        <!--:on-preview="handlePreview"-->
        <!--:on-remove="handleRemove"-->
        <!--:show-file-list="false">-->
        <!--<el-button icon="icon-upload-image"></el-button>-->
        <!--</el-upload>-->
        <!--<el-upload-->
        <!--class="upload-demo"-->
        <!--action="https://jsonplaceholder.typicode.com/posts/"-->
        <!--:on-preview="handlePreview"-->
        <!--:on-remove="handleRemove"-->
        <!--:show-file-list="false">-->
        <!--<el-button icon="icon-upload-file"></el-button>-->
        <!--</el-upload>-->
      </div>
    </div>
    <div v-else>
      <el-row class="display-message text-center">
        <h2>{{ $t('message-box.no-chat-selected.text') }}</h2>
      </el-row>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { dataGet } from '@fps/vue-toolkit/dist/util';
  import { mapState } from 'vuex';
  import debounce from 'lodash-es/debounce';
  import ResourcePage from '@/components/Core/ResourcePage';
  import ChatMessage from './ChatMessage';
  import EntityList from '../Core/EntityList';
  import reverse from '../../filter/reverse';
  Vue.prototype.lazyLoadPackages.echo.load();

  export default {
    components: {
      EntityList,
      ChatMessage,
    },
    extends: ResourcePage,
    data() {
      return {
        resource: 'messages',
        isUserLogged: false,
        content: '',
        sort: [['created_at', 'desc']],
        form: {},
        resourceOptions: {
          'user:file': true,
          'ad:file': true,
          'ad:currency': true,
          'ad:user:file': true,
        },
        isWriting: false,
        channel: null,
        commonChannel: null,
        isWritingDebounce: null,
        writingDebounce: null,
        lastScrollHeight: 0,
        loadLazyImagesDebounce: debounce(this.loadLazyImages.bind(this), 300)
      };
    },
    computed: {
      adCurrency() {
        return this.messageSample.ad && this.messageSample.ad.currency
          ? this.messageSample.ad.currency.symbol : null;
      },
      receiverUser() {
        return dataGet('id', this.user) !== dataGet('user.id', this.messageSample) ? dataGet('user', this.messageSample)
          : dataGet('ad.user', this.messageSample);
      },
      hasData() {
        return this.$route.params.userId && this.$route.params.adId;
      },
      ...mapState({
        isMobile: state => state.isMobile,
        locale: state => state.locale,
        reverseTextForLocals: state => state.filters.reverseTextForLocals,
        user: state => state.auth.user,
        messageSample(state) {
          const message = dataGet('temp.messages.list.0', state);
          if (message && this.user) {
            const otherUser = message.user_id === this.user.id ? dataGet('ad.user', message) : message.user;
            if (message && otherUser) {
              return {
                ...message,
                created_by: otherUser.id,
              };
            }
          }
          return null;
        },
      }),
      filter() {
        return [{
          property: 'user_id',
          operator: '=',
          value: this.$route.params.userId,
        }, {
          property: 'ad_id',
          operator: '=',
          value: this.$route.params.adId,
        }];
      },
    },
    watch: {
      content(now, before) {
        if (now !== before && this.writingDebounce) {
          this.writingDebounce();
        }
      },
      $route: {
        handler(route) {
          this.initMessageBox(route, true);
        },
        deep: true
      },
    },
    mounted() {
      this.writingDebounce = debounce(() => {
        this.commonChannel
          .whisper('writing', true);
      }, 300);

      this.isWritingDebounce = debounce(() => {
        this.isWriting = false;
      }, 5000);

      this.initMessageBox(this.$route);
    },
    beforeDestroy() {
      if (this.channel) {
        this.channel.unbind();
      }

      if (this.commonChannel) {
        this.commonChannel.unbind();
      }

      if (this.$refs.scrollWrapper) {
        this.$refs.scrollWrapper.$el.removeEventListener('scroll', this.scroll);
      }
    },
    methods: {
      goToAd(id) {
        this.$router.push({ name: 'Ad', params: { id } });
      },
      userAction(type) {
        this.loading = true;
        const userId = this.user.id;
        const entityUserId = this.messageSample.user_id !== userId ?
          this.messageSample.user_id : this.messageSample.ad.user.id;
        const data = type === 'report' ?
          { user_id: userId, reported_user_id: entityUserId } :
          { user_id: userId, blocked_user_id: entityUserId };
        if (userId && entityUserId) {
          this.$http.post(`/user/${type}`, data)
            .then((response) => {
              this.loading = false;
              if (response) {
                this.$emit('reloadUsersList', true);
              }
            })
            .catch(({ response }) => {
              this.onFormError(response);
            });
        }
      },
      initMessageBox(route, routeChange = false) {
        if (route.params.userId && route.params.adId) {
          this.channel = this.$echo.private(`App.Models.User.${this.user.id}`);
          this.commonChannel = this.$echo.private(`Chat.${route.params.userId}.${route.params.adId}`);

          if (
            routeChange
              && this.$refs.messagesBox
          ) {
            this.$nextTick(() => {
              this.$refs.messagesBox.doRefresh();
            });
          }

          setTimeout(() => {
            this.channel
              .notification(this.handleNotification.bind(this));

            this.commonChannel
              .listenForWhisper('writing', () => {
                this.isWriting = true;
                this.scrollOnResponse(100);
                this.isWritingDebounce();
              });

            if (this.$refs.scrollWrapper) {
              this.$refs.scrollWrapper.$el.removeEventListener('scroll', this.scroll);
              this.$refs.scrollWrapper.$el.addEventListener('scroll', this.scroll);
            }
          });
        }
      },
      scrollOnResponse(delay = 0, scrollDiff = false) {
        setTimeout(() => {
          if (this.$refs.scrollWrapper) {
            if (scrollDiff) {
              // Keep the current scroll position
              this.$refs.scrollWrapper.$el.scrollTo({
                top: (
                  this.$refs.scrollWrapper.$el.scrollHeight - this.lastScrollHeight),
              });
            } else if (
              // If the scroll is all the way to the bottom keep scroll position
              this.lastScrollHeight ===
              this.$refs.scrollWrapper.$el.clientHeight + this.$refs.scrollWrapper.$el.scrollTop
            ) {
              // Scroll to the bottom
              this.$refs.scrollWrapper.$el.scrollTo({
                top: this.$refs.scrollWrapper.$el.scrollHeight,
              });
            }
            this.lastScrollHeight = this.$refs.scrollWrapper.$el.scrollHeight;
            this.$refs.scrollWrapper.$el.scrollTo({
              top: this.$refs.scrollWrapper.$el.scrollHeight,
            })
          }
        }, delay);
      },
      initialScroll() {
        let counter = 10;
        const interval = setInterval(() => {
          counter -= 1;
          // Scroll to the bottom
          if (this.$refs.scrollWrapper) {
            this.$refs.scrollWrapper.$el.scrollTo({
              top: this.$refs.scrollWrapper.$el.scrollHeight,
            });
          }

          if (!counter) {
            clearInterval(interval);
          }
        }, 100);
      },
      handleNotification(notification) {
        if (notification && notification.notificationType) {
          switch (notification.notificationType) {
            case 'message.new':
              // If its for the current active chat
              if (
                Number(notification.user_id) === Number(this.messageSample.user_id) &&
                Number(notification.ad_id) === Number(this.messageSample.ad_id)
              ) {
                this.pushMessage(notification);
                setTimeout(() => {
                  this.isWriting = false;
                }, 600);
              }
              break;
            default:
          }
        } else {
          throw new Error('Cant handle notification, no notificationType property exists.');
        }
      },
      reverse(list) {
        return reverse(list);
      },
      // handleRemove(file, fileList) {
      //   // eslint-disable-next-line no-console
      //   // console.log(file, fileList);
      // },
      // handlePreview(file) {
      //   // eslint-disable-next-line no-console
      //   console.log(file);
      // },
      submit(event) {
        if (!event.shiftKey) {
          this.content = this.content.replace(/\n$/, '');
          this.loading = true;
          const content = this.content;
          this.content = '';
          this.provider.add({
            user_id: this.$route.params.userId,
            ad_id: this.$route.params.adId,
            content,
          })
            .then(({ data }) => {
              this.loading = false;
              if (this.$refs.messagesBox) {
                this.pushMessage(data);
              }
            })
            .catch(({ response }) => {
              if (response.data.errors.user_id) {
                this.$message({ type: 'error',
                  message: ` ${this.$t('ad.write-message-disabled.text')}`,
                });
              }
              this.onFormError(response);
              this.loading = false;
              this.content = content;
            });
        }
      },
      pushMessage(data) {
        this.$refs.messagesBox.items.unshift({
          ...data,
          user: this.messageSample.user,
          ad: this.messageSample.ad,
        });
        this.scrollOnResponse(100);
      },
      loadLazyImages () {
        if (this.$refs.chatMessage && this.$refs.chatMessage.length) {
          this.$refs.chatMessage.forEach((chatMessage) => {
            chatMessage.loadImage()
          })
        }
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AccountSettings/MessageBox.vue